import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeAttachment } from "../Entity/TreeNodeAttachment";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsAttachments extends Art57NodeList{
    items: any;
    labelPrefix: string;
    cloningNode: boolean = false;

    constructor(injector: Injector, labelPrefix: string, parent: any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `${labelPrefix} Attachments (${(items&&items.length>0)?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.items = items;
        this.labelPrefix = labelPrefix;
        this.labelNodeName = this.labelPrefix + ' Attachments';

        if (this.cloningNode) {
            return;
        }

        for (const item of items || []) {
            this.children?.push(new TreeNodeAttachment(injector,item,this));
        }
    }

    override getHeaders(): string[] {
        return ['Attachment EV Code', 'Type', 'Owner Identifier', 'Owner HQ Identifier', 
                'Attachment Language', 'Attachment Name', 'Attachment File Name', 'Attachment File', 
                'Type', 'Version Date', 'Version Date Format','Version Number'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsAttachments = new TreeNodeMedicinalProductsAttachments(this.ioc!,this.labelPrefix,newParent, true, this.items);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }
         
}